import { render, staticRenderFns } from "./RsaGestioneAssistitiPage.vue?vue&type=template&id=711f1b96"
import script from "./RsaGestioneAssistitiPage.vue?vue&type=script&lang=js"
export * from "./RsaGestioneAssistitiPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports